import SyncRoundedIcon from "@mui/icons-material/SyncRounded";
import moment from "moment";

import { ConfirmPopUp } from "../../../../components/PopUp";
import type { ConfirmDetail } from "../../../../components/PopUp/confirmShared/types";
import {
  formatSignedAmount,
  getAmountVariant,
  getCardTitle,
  getFrequencyLabel,
} from "../RecurringSection/utils";
import { RecurringEditWarningProps } from "./types";


const HIDE_WARNING_KEY = "hideRecurringEditWarning";

export const RecurringEditWarning = ({
  isOpen,
  transaction,
  onConfirm,
  onCancel,
}: RecurringEditWarningProps) => {
  const buildDetail = (): ConfirmDetail | undefined => {
    if (!transaction) {
      return undefined;
    }

    const variant = getAmountVariant(transaction.transactionType);
    const frequencyLabel = getFrequencyLabel(
      transaction.frequency,
      transaction.interval,
    );
    const nextDate = moment(transaction.nextExecutionDate).format("D MMM YYYY");

    return {
      icon: <SyncRoundedIcon />,
      title: getCardTitle(transaction),
      subtitle: `${frequencyLabel} · next ${nextDate}`,
      amount: formatSignedAmount(transaction.amount, variant),
      amountVariant: variant,
    };
  };

  const detail = buildDetail();

  const description = (
    <>
      Your changes will apply to <strong>all future occurrences</strong>.
      Transactions already generated by this schedule will be left as they are.
    </>
  );

  return (
    <ConfirmPopUp
      isOpen={isOpen}
      setIsOpen={() => onCancel()}
      tone="warning"
      title="Edit this recurring transaction?"
      text={description}
      details={detail}
      confirmLabel="Continue to edit"
      cancelLabel="Cancel"
      showDontAskAgain
      dontAskAgainKey={HIDE_WARNING_KEY}
      onConfirm={onConfirm}
    />
  );
};
